function processApiGetters(modules) {
    _.keys(modules).forEach(moduleName => {
        var module = modules[moduleName];
        if (!module.apiGetters) return;

        var apiGetters = module.apiGetters;

        _.keys(apiGetters).forEach(name => {
            let key = "$state_" + name;
            module.state[key] = null;

            module.getters[name] = state => {
                if (state[key] == "loading") return null;
                if (state[key] === null) {
                    getData(apiGetters[name], state, key);
                    return null;
                } else {
                return state[key];
                }
            }
            var actionName = "get" + _.capitalize(name[0]) + name.substring(1);
            module.actions[actionName] = async (context) => {
                return await getData(apiGetters[name], context.state);
            }
        });
    });
}

async function getData(apiGetter, state, key) {
    state[key] = "loading";
    if (_.isString(apiGetter)) {
        state[key] = await romeApi.get(apiGetter);
    } else if (_.isFunction(apiGetters[name])) {
        state[key] = await apiGetters[name]();
    } else {
        throw "apiGetter should be URL or async function"
    }

    return state[key];
}

export function extendStoreModules(modules) {
    _.keys(modules).forEach(moduleName => {
        var module = modules[moduleName];
        if (!module.actions) module.actions = {};
        if (!module.mutations) module.mutations = {};
        if (!module.getters) module.getters = {};
    });

    processApiGetters(modules);
}



// WEBPACK FOOTER //
// ./src/framework/utils/store-utils.js